

class Element {

  /**
   * @param position_cb Callback returning
   *   { left: {float}, top: {float}, right; {float}, bottom: {float} }
   */
  constructor(position_cb) {
    this.position_cb = position_cb;
  }

  updatePos = () => {
    Object.assign(this, this.position_cb());
  };

  renderBBox = (canvas) => {
    this.updatePos();

    // top line
    const ctx = canvas.getContext("2d");
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 1;

    ctx.beginPath();
    ctx.rect(this.left, this.top, this.right - this.left, this.bottom - this.top);
    ctx.stroke();
  }

  width = () => {
    return this.right - this.left;
  }

  height = () => {
    return this.bottom - this.top;
  }

  render = (canvas, tickData) => { }

}

export { Element };
